import React, { Component } from 'react'
import { observer } from 'mobx-react'
import UIMultipleRating from '@ui/QuestionsType/MultipleRating'

@observer
export default class MultipleRating extends Component {
  handleChange = (answers, _, currentAnswer) => {
    const { mapped, onPartial } = this.props
    mapped.perfectScoreCounter(currentAnswer)
    onPartial(answers)
  }

  render() {
    const { mapped, inactive } = this.props
    const { rateValues, items: mappedRows, answer } = mapped

    return (
      <UIMultipleRating
        columns={rateValues}
        rows={mappedRows}
        onChange={this.handleChange}
        selected={answer}
        inactive={inactive}
      />
    )
  }
}
